module.exports = __webpack_public_path__ + "794d2a855a42adc6fd301f957be400d6.ico";


//////////////////
// WEBPACK FOOTER
// ./app/images/favicon.ico
// module id = 465
// module chunks = 0